export default {
  route: {
    Permission: 'Permission',
    RoleFrontPermission: 'Front Desk Permission',
    RoleBackPermission: 'Backend Permission',
    Setting: 'System Settings',
    UserManager: 'User Management ',
    UserList: 'List of Users',
    AddressManager: 'Address Management',
    AddressList: 'Address List ',
    AddAddress: 'Add New Address',
    MeterManager: 'Meters Management',
    Operate: 'Logs',
    MeterList: 'Meters List',
    MalfunctionList: 'Meter Fail',
    LeakageList: 'Leakage Meters List',
    OrderList: 'Payment List',
    UserProfile: 'User Info',
    Account: 'Administrator',
    AccountInfo: 'Administrator Info',
    UpdatePassword: 'New Password',
    About: 'About',
    AccountList: 'List of Administrators',
    Overview: 'Overview',
    AdminInfo: 'Admin Info',
    UserBill: 'Payment',
    CostsSet: 'Charge Plan',
    InstallerUser: 'Installer',
    Message: 'Notifications',
    Holiday: 'Public Holiday',
    SystemManagement: 'System Settings',
    AdminManagement: 'Administrators ',
    CompanyList: 'Company List',
    FirewareList: 'Firmware',
    Network: 'Network',
    AddRsNetwork: "Add RS485 Network",
    RsNetwork: "RS485 Network",
    AddCompany: 'Create Company',
    AddAdmin: 'Add New Admin User',
    AddCostSet: 'Add Payment Rule',
    AddHoliday: 'Add Public Holiday',
    AddUser: 'Add New User',
    AddInstallUser: 'Add New Installer',
    AddFireware: 'Add Firmware',
    MeterAnalyze: 'Meter Analysis',
    UserSetting: 'User Settings',
    AddMeter: 'Add New Meter',
    MeterFirewareList: 'Meter List For FW upgrade',
    Devices: 'Add/Delete Devices',
    DeviceControl: 'Device Control',
    DeviceSchedule: 'Device Schedule',
  },
  navbar: {
    logOut: 'Logout',
    dashboard: 'Home',
    github: 'Item Address',
    theme: 'Theme',
    size: 'Theme Size',
  },
  common: {
    warning: 'Warning',
    success: 'Success',
    company: 'Company',
    name: 'Name',
    batchManager: 'Batch Process',
  },
  moneyUnit: {
    unit: 'Unit',
    JPY: 'JPY',
    CNY: 'CNY',
    USD: 'USD',
  },
  language: {
    name: 'Language',
    CN: '中文',
    JAP: '日本語',
    English: 'English',
  },
  login: {
    title: 'Title',
    logIn: 'Login',
    rememberMe: 'Auto Login',
    username: 'User Name',
    password: 'Password',
    comfirmPassword: 'Confirm Password',
    any: 'Optional',
    thirdparty: 'Third Party Login',
    forgetPassword: 'Forgot Password',
    sendCode: 'Send Verification Code',
    verificationCode: 'Verification Code',
  },
  documentation: {
    documentation: 'Documents',
    github: 'Github Address',
  },
  permission: {
    addRole: 'Add Role',
    editPermission: 'Edit',
    roles: 'Role',
    switchRoles: 'Switch Role',
  },
  meterState: {
    s10: 'Battery Voltage',
    s11: 'Valve Status',
    s12: 'Terminal Cover',
    s13: 'Clock Syn',
    s14: 'Leakage',
    s15: 'Reverse Flow',
    s16: 'High Flow',
    s17: 'Comm Event',
    s18: 'Water Meter Event',
    s21: 'Power Outage',
    s24: 'Electricity',
    s25: 'Time Switch Setting',
    s26: 'Voltage',
    s28: 'Power Meter Event',
    s32: 'Gas Stop',
    s35: 'Gas Pressure',
    s36: 'Shock',
    s48: 'Heat Meter Event',
    s50: 'Battery Level',
    s51: 'Wi-SUN Communication',
    s54: 'Sunshine Meter',
    s58: 'Meter Event',
    fault: 'Error',
    leakage: 'Leakage',
    noData: 'No data for last 4 hours',
  },
  usage: {
    usage: 'Usage',
    importEngery: 'Import Engery',
    exportEnergy: 'Export Energy',
    pVEnergy: 'Generated Energy',
    current: 'Current',
    voltage: 'Voltage',
    frequency: 'Frequency',
    current1: "Current1",
    voltage1: "Voltage1",
    frequency1: "Frequency1",
    activePower1: 'Active Power1',
    reactivePower1: 'Reactive Power1',
    current2: "Current2",
    voltage2: "Voltage2",
    frequency2: "Frequency2",
    activePower: 'Active Power',
    reactivePower: 'Reactive Power',
    activePower2: 'Active Power2',
    reactivePower2: 'Reactive Power2',
    pyranometer: 'Pyranometer',
    pulseCountUsage: "Pulse Count Usage",
    temperature: "Temperature",
    humidity: "Humidity",
    routeBImportEnergy: "RouteB Import Energy",
    routeBExportEnergy: "RouteB Export Energy",
    pvExportEnergyUsage: "PV Export Energy",
  },
  table: {
    dynamicTips1: 'Fixed Meter Order',
    dynamicTips2: 'Non-Fixed Meter Order',
    dragTips1: 'Default Order ',
    dragTips2: 'Drag Order',
    title: 'Title',
    importance: 'Importance',
    type: 'Type',
    remark: 'Remarks',
    search: 'Search',
    add: 'Add',
    export: 'Export',
    reviewer: 'Reviewer',
    id: 'Serial Number',
    date: 'Time',
    author: 'Author',
    readings: 'Read Count',
    status: 'Status',
    actions: 'Operations',
    edit: 'Edit',
    publish: 'Publish',
    draft: 'Draft',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    update: 'Update',
    update1: 'Update',
    new: 'Add New',
    chart: 'Chart',
    map: 'Map',
    reset: 'Reset',
    send: 'Send',
    startTime: 'Start Time',
    endTime: 'End Time',
    nextPage: 'Next Page',
    prePage: 'Pre Page',
    createTime: 'Create Time',
    preUpdate: 'Previous Update',
    detail: 'Details',
    updateDate: 'Update Date',
    disable: 'Disable',
    enable: 'Enable',
    disableState: 'Disable Status',
    return: 'Return',
    clearForm: 'Clear Form',
    set: 'Set',
    get: 'Get',
    upload: "Upload",
    browse:"Browse",
    crc:"CRC",
    meter:"Meter"
  },
  element: {
    pleaseEnter: 'Please Enter',
    pleaseSelect: 'Please Select',
    inputKeyWords: 'Input Keywords',
    selectDate: 'Select Date',
    selectDateTime: 'Select Time',
    selectMultiDate: 'Select Date',
    selectAll: "Select All",
    check: "Check",
  },
  excel: {
    export: 'Export',
    selectedExport: 'Export Selected',
    placeholder: 'Input File Name',
    refresh: 'Refresh',
  },
  tagsView: {
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All',
  },
  company: {
    name: 'Name',
    logo: 'Logo',
    address: 'Address',
    webURL: 'URL',
    email: 'E-Mail',
    phone: 'Phone',
    parentCompanyName: 'Parent Company',
    messageDate: 'Message Date',
    paymentDate: 'Payment Date',
    zone: 'Time Zone',
    disableCompany: 'Diable Company',
    enableCompany: 'Enable Company',
    leakageSetting: 'Leakage Percent',
    waterLeakage: 'Water Leakage',
    powerLeakage: 'Power Leakage',
    gasLeakage: 'Gas Leakage',
    hotLeakage: 'Hot Leakage',
  },
  fireware: {
    name: 'Firmware Name',
    url: 'Firmware Location',
    uploadFireware: 'Upload Firmware',
    upload: 'Upload',
    version: 'Version',
    deleteFireware: 'Delete Firmware',
    pleaseSelectFireware: 'Please Select Firmware',
    note: 'Note',
    moduleModel: 'Module Model',
    firmwareFileSize: 'Firmware file size',
    selectFirmwae: 'Select Firmware',
    selectedMeters: 'Selected Meters',
    uploadMeters: 'Upload Meters',
    uploadFile: 'Upload File'
  },
  meter: {
    meterID: 'Meter ID',
    subPowerMeter: "Collector Meter",
    meterType: 'Meter Type',
    ownUser: 'User',
    setMeterParent: 'Set Parent Meter',
    changeMeterParent: 'Change Parent Meter',
    parentMeterID: 'Parent Meter ID',
    unitPrice: 'Unit Price',
    addMeterCost: 'Add Cost',
    updateMeterCost: 'View Cost',
    deleteMeterCost: 'Delete Cost',
    leakageQuantity: 'Leakage Limit',
    reportTime: 'Report Time',
    maintainReportTime: 'Maintenance',
    faultType: 'Fault Type',
    life: 'Life',
    maxReading: 'Max Reading',
    bRouteMaxReading: 'Route B Max Reading',
    cycle: 'Maintenance Cycle',
    installDate: 'Install Date',
    state: 'Meter State',
    address: 'Address',
    parentMeter: 'Parent Meter',
    usage: 'Usage',
    reads: 'Reading',
    cost: 'Cost',
    expireDate: 'Expire Date',
    selectTime: 'Select Time',
    message: 'Message',
    batchSetParent: 'Set Parent',
    batchWrite: 'Meter Settings',
    reading: 'Reading',
    ota: 'OTA Update',
    broute: 'B-Route',
    brouteID: 'B-Route ID',
    brouteSecret: 'B-Route Secret',
    GetInfo: "Get Info",
    openValve: 'Open Valve',
    closeValve: 'Close Valve',
    clockSync: 'Clock Sync',
    electric: 'Electricity',
    openLoad: 'Open Load',
    closeLoad: 'Close Load',
    loadControl: 'Load Control',
    timeSwitchcontrol: 'Time Switch control',
    otherControl: 'Others Control',
    alarm: 'Alarm',
    alarmList: 'Alarm List',
    installerUser: 'Installer',
    bindUser: 'Bind User',
    analyze: 'Analysis',
    deleteMeter: 'Delete Meter?',
    disableMeter: 'Disable Meter',
    enableMeter: 'Enable Meter',
    meterReading: 'Meter Readering',
    eventLog: 'Event Log',
    eventLogForRs485: 'Event Log (for RS485 Slave)',
    clearKey: "clear key",
    resetPointer: "Reset Pointer",
    resetMeter: "Reset Meter",
    resetCommModule: "Reset Comm Mudule",
    resetDailyMeter: "Reset Daily Meter",
    selectLocation: "select location",
    powerConditioner: "External Device",
    Instant: 'Instant',
    RangedEnergyReading: 'Ranged Energy Reading (for RS485 Slave)',
    RangedEventLog: 'Ranged Event Log',
    InstantPowerLineValue: 'Instant Power Line Value',
    ReadPowerLineValue: 'Get Power Line Value',
    GetVersionInfo: 'Get meter ID and version information',
    Get30minRecordLogWithVoltage: "Get 30min record log with voltage",
    Get30minRecordLog: "Get 30min record log",
    GetDiagnosticInformation: "Get diagnostic information",
    DiagnosticInformation: "Diagnostic Information",
    ConfirmClearKey: 'Warning: Are you sure you want to clear the key?',
    versionCheck: 'Version Check',
    upgrade: 'Upgarde',
    batchUpgrade: 'Batch Upgrade',
    subMeter: 'sub Meter',
    NetworkName: "Network Name",
    NetworkBaudRate: "Network Baud Rate",
    Master: 'Master',
    Slave: 'Slave',
    NumberOfSlaveNumber: 'Number of Slave Number',
    ControlPanel: "Control Panel",
    Advance: 'Advance',
    SlaveMeterID: 'Slave Meter ID',
    UnitNO: 'Unit NO',
    ManualCommand: 'Manual Command',
    AdvanceCommands: 'Advance Commands',
    Response: 'Response',
    LastReportTime: 'Last Report Time',
    Import: "Import",
    Export: "Export",
    PulseInputCount: "Pulse Input Count",
    MeterStatu: "Meter Status",
    Current: "Current",
    Voltage: "Voltage",
    Frequency: "Frequency",
    Start: "Start",
    End: "End",
    Command: 'Command',
    readingRecords: 'Get Records',
    reCalculateUsage: "Reset Data",
    meterVersion: 'Meter FW ver.',
    moduleId: 'Module ID',
    moduleVersion: 'Module FW ver.',
    pulseFactor: "Pulse Factor",
    simCardInfo: "SIM card info",
    imsi: "IMSI",
    apn: "APN",
    user: "User",
    password: "Password",
    authenication: "Authenication",
    authenicationTypes: ["None", "PAP", "CHAP", "PAP or CHAP"],
    ipAddressAndPort: "IP address and Port No",
    ipAddress: "IP address",
    port: "Port",
    atuoRead: "Auto Read",
    wifi: "Wi-Fi",
    wifiSSID: "Wi-Fi SSID",
    wifiPassword: "Wi-FI Password",
    sta: "STA",
    staSSID: "STA SSID",
    staPassword: "STA Password",
    mqttType: "サーバータイプ",
    powerPlantId: 'Powerｐlant　ID',
    uploadSchedule: 'Schedule Upload',
    cpc:'Program CPC',
    rs485SwitchControl:'RS485開關控制'
  },
  schedule: {
    stableSchedule:"Annual Schedule",
    stableVersion:"Version",
    updateSchedule:"Renewal Schedule",
    updateVersion:"Renewal Flag",
    updateInterval:"Update Interval",
    count:"Data Volumn",
    scheduleUpload:"Schedule Upload"
  },
  device: {
    device: "Device",
    class: 'Class',
    className: 'Class Name',
    deviceId: 'Device ID',
    status: 'Status',
    inUse: 'In Use',
    getProperty: "Get Property",
    oneProperty: "One Property",
    mulitProperty: "Mulit Property",
    propertyName: "Property name",
    epc: "EPC",
    accessRule1: "accessRule1",
    accessRule2: "accessRule2",
    readingInputData: "Reading / Input Data",
    lastUpdateOn: "Last update on",
    remarks: "Remarks",
    sequenceOfData: "Sequence of Data",
    downloadBuffer: "Download Buffer",
    reloadBuffer: "Reload Buffer",
    scheduleJson: "定时JSON命令"
  },
  message: {
    maintenancePlan: 'Maintenance Plan',
    expireMessage: 'Expire Notice',
    preNotifyDays: '{0} Days Before',
    NotifyDays: '{0} Date',
    defaultSevenDays: 'Default Days',
  },
  location: {
    location: 'Location',
    latlng: 'Latitude&Longitude',
    longitude: 'Longitude',
    latitude: 'Latitude',
    country: 'Country',
    province: 'Province',
    city: 'City',
    detail: 'Detail Address',
    street: 'Street',
    meterCount: 'Meter Count',
    userCount: 'User Count',
    totalUsage: 'Total Usage',
    totalCost: 'Total Cost',
  },
  diableState: {
    disabled: 'Disabled',
    enabled: 'Enabled',
  },
  meterTypes: {
    water: 'Water',
    power: 'Power',
    gas: 'Gas',
    hot: 'Heat',
    pv: 'PV',
  },
  meterTypeArray: ['Water', 'Power', 'Gas', 'Heat', 'PV', 'Meter Gateway', 'Meter Gateway - Wi-Fi'],
  subMeterTypeArray: [
    ["Pluse Type", "Non-Pulse Type", "Remote unit"],
    ["Sub Meter", "Sub Meter with Pulse input", "Sub Meter RS485 - Master", "Sub Meter RS485-Slave"],
    ["Pluse Type", "Non-Pulse Type", "Remote unit"],
    [],
    ["Single Direction ", "Bi-Direction"],
    [],
  ],
  firmwareType: {
    water: 'Water',
    power: 'Power',
    gas: 'Gas',
    hot: 'Heat',
    pv: 'PV',
    gateway: 'Meter Gateway',
    gateway_wifi: 'Meter Gateway - Wi-Fi',
    cert:"Cert",
    ca_cert: 'CA cert',
    client_cert: 'Client cert',
    client_key: 'Client key',
    pcs_ca_ert:'PCS CA cert',
  },
  timeArray: {
    hours: 'Hours',
    days: 'Days',
    weeks: 'Weeks',
    months: 'Months',
    years: 'Years',
  },
  stateInfos: {
    totalCount: 'Total Count',
    malfunctionCount: 'Malfunction Count',
  },
  date: {
    year: 'Year',
    month: 'Month',
    day: 'Day',
  },
  user: {
    email: 'E-Mail',
    userID: 'User ID',
    userName: 'User Name',
    portrait: 'User Icon',
    address: 'Address',
    editUser: 'Edit User',
    phone: 'Phone',
    password: 'Password',
    oldPassword: 'Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    deleteUser: 'Delete User',
    frontRole: 'Front Desk Role',
    backRole: 'Backend Role',
    role: 'Role',
    position: 'Title',
    disableAdmin: 'Disable Admin',
    enableAdmin: 'Enable Admin',
    disableUser: 'Disable User',
    enableUser: 'Enable User',
  },
  order: {
    payTime: 'Paid Date',
    createTime: 'Create date',
    money: 'Amount',
    payState: 'Payment Status',
    alredayPay: 'Paid',
    notPay: 'Not Settled',
    sendEmail: 'Send E-Mail',
  },
  costSet: {
    name: 'Charge Plan',
    normal: 'Charge Rules',
    addHolidayDate: 'Add Date',
    saturday: 'Saturday',
    sunday: 'Sunday',
    holiday: 'Public Holiday',
    addRule: 'Add Rule',
    ruleType: 'Rule Type',
    timeRule: 'Time Based Rule',
    usageRule: 'Usage Based Rule',
    startTime: 'Start Time',
    endTime: 'End Time',
    startUsage: 'Start Usage',
    endUsage: 'End Usage',
    please_input_usage: 'Please enter usage',
    please_input_end_usage: 'Please fill in maximum reading, default value is 99999999',
    nextCostSet: 'Pre-payment Plan',
    nextCostSetDate: 'Update Time',
  },
  operate: {
    action: 'Actions',
    path: 'Path',
  },
  notification: {
    alreadyLastPage: 'Last Page',
    pleaseInputAllAddressInfo: 'Please Input All Address Info',
    pleaseInputName: 'Please Input Name',
    pleasePickOneDateAtLeast: 'Select at least one date',
    saveSuccess: 'Save Success',
    saveFail: 'Save Fail',
    pleaseInputAll: 'Please fill in all field',
    inputIllegal: 'Illegal Input',
    addCompanySuccess: 'Add Company Success',
    addAdminSuccess: 'Add Admin User Success',
    getEmailSuccess: 'Get E-mail Success',
    changePasswordSuccess: 'Change Password Success',
    addHolidaySuccess: 'Add Public Holiday Success',
    getEmailError: 'Get Verification Code Error',
    emailCodeAlreadySend: 'Verification Code sent',
    dataPackageSendSuccess: 'Data package send success!',
    addUserSuccess: 'Add User Success',
    addInstallUserSuccess: 'Add Installer Success',
    updateUserInfoSuccess: 'Update User Info Success',
    AddFirewareSuccess: 'Add Firmware Success',
    AddMeterCostSuccess: 'Add Charge Plan Success',
    DeleteMeterCostSuccess: 'Delete cost plan success',
    BatchSetParentSuccess: 'Batch Set Parent Meter Success',
    BatchBindUserSuccess: 'Batch Binding Success',
    BatchBindMeterCostSuccess: 'Batch Binding Charge Plan Success',
    PleaseSelectMeterID: 'Please Select ID',
    PleaseSelectUser: 'Please Select User',
    PleaseSelectMeterCoust: 'Please Select Charge Plan',
    UpdateAdminSuccess: 'Update Admin User Info Success',
    DeleteAdminSuccess: 'Delete Admin User Success',
    UpdatePasswordSuccess: 'Update password success, please Login again.',
    MeterCostDateError: 'Charge Plan Change Illegal ',
    UploadSuccess: 'Upload success!',
    DisableCompanySuccess: 'Disable company success!',
    EnableCompanySuccess: 'Enable company success!',
    DisableAdminSuccess: 'Disable administrator success!',
    EnableAdminSuccess: 'Enable administrator success!',
    DisableMeterSuccess: 'Disable meter success!',
    EnableMeterSuccess: 'Enable meter success!',
    DateRangeHaveNoData: 'Date range with no data!',
  },
  validate: {
    onlyNumberPermission: 'Numbers Only',
    cannotGreaterThan30: 'Only value less than 30 is allowed',
    passwordMustGreaterThan8: 'Password must larger than 8 characters',
    twoPasswordNotEqual: 'Two password are not match',
    email: 'Please input valid Email',
    valueNotNull: 'Value cannot be empty',
  },
  param: {
    param1: 'Parameter 1',
    param2: 'Parameter 2',
    param3: 'Parameter 3',
    startTime: 'Start Time',
    endTime: 'End Time',
  },
  routeDetail: {
    adminSignIN: 'Administrator sign in',
    adminSignUP: 'Administrator sign up',
    adminLogout: 'Administrator logout',
    getAdminList: 'Get administrator list',
    updateAdminPassword: 'Update administrator password',
    updateAdmin: 'Update administrator info',
    deleteAdmin: 'Delete administrator',
    createInstallUser: 'Create user',
    forgetAdminPassword: 'Forgot password',
    addPermissions: 'Add permissions',
    deletePermissions: 'Delete permissions',
    bindRole: 'Add administrator role',
    updateRole: 'Update administrator role',
    deleteRole: 'Delete administrator role',
    users: 'Get users list',
    addMeter: 'Add meter',
    updateMeter: 'Update meter',
    meters: 'Get meter list',
    setMeterParent: 'Set parent meter',
    changeMeterParent: 'Change parent meter',
    leakages: 'Get leakage meter list',
    orders: 'Bill list',
    meterFaults: 'Meter fault message',
    addMeterCost: 'Add cost plan',
    deleteMeterCost: 'Delete cost plan',
    updateMeterCost: 'Update cost plan',
    getMeterCosts: 'Get cost plan list',
    addHolidaysDate: 'Add holiday date',
    deleteHolidaysDate: 'Delete holiday date',
    updateHolidaysDate: 'Update holiday date',
    getHolidaysDates: 'Get holiday list',
    createCompany: 'Create company',
    deleteCompany: 'Delete company',
    updateCompany: 'Update company',
    getCompanys: 'Get company list',
    createFireware: 'Add fireware',
    deleteFireware: 'Delete fireware',
    updateFireware: 'Update fireware',
    getFirewares: 'Get fireware list',
    exportMeterDatas: 'Export meter datas',
  },
  brandNames: ['OMRON', 'DeltaOHM', "Huawei", "Panasonic", "IIL"],
  ModelNames: ['KP_M', 'KPK / KPV / KPW', 'HD9817TVS', 'SUN2000L-5ktl', 'VBPC244GM2S',"IIL2312"],
  Model2DataItems: ['DC input voltage [1]', 'DC input voltage [2]', 'DC input voltage [3]', 'DC input voltage [4]', 'DC input current [1]', 'DC input current [2]', 'DC input current [3]',
    'DC input current [4]', 'DC input current (Total input)', 'Generated power', 'System W-phase V', 'System U-phase V', 'System frequency', 'Total accumulated power', 'Operation status', 'Indication error code', 'Rated output'],
  Model1DataItems: ['Operation status', 'DC input voltage', 'DC input current', 'System U-phase V', 'System W-phase V', 'Generated power', 'Solor intensity', 'Temperature', 'Total accumulated power', 'User accumulated power', 'DC input voltage [1]',
    'DC input current [1]', 'DC input voltage [2]', 'DC input current [2]', 'DC input voltage [3]', 'DC input current [3]', 'DC input voltage [4]', 'DC input current [4]'],
  Model3DataItems: ["Temperature", "Temperature", "Relative humidity", "Dew Point", "Dew Point", "Wet bulb temperature", "Wet bulb temperature", "Status register"],
  ModelHuaweiDataItems: ['Model', 'SN', 'PN', 'Model ID', 'Number of PV strings', 'Number of MPP trackers', 'Rated power (Pn)', 'Maximum active power (Pmax)', 'Maximum apparent power(Smax)', 'Maximum reactive power(Qmax fed to the power grid)',
    'Maximum reactive power(Qmax absorbed from the power grid)', 'State 1', 'State 2', 'State 3', 'Alarm 1', 'Alarm 2', 'Alarm 3', 'PV1 voltage', 'PV1 current', 'PV2 voltage',
    'PV2 current', 'PV3 voltage', 'PV3 current', 'PV4 voltage', 'PV4 current', 'Input power', 'Power grid voltage/Line voltage between phases A and B', 'Line voltage between phases B and C', 'Line voltage between phases C and A', 'Phase A voltage',
    'Phase B voltage', 'Phase C voltage', 'Power grid current/Phase A current', 'Phase B current', 'Phase C current', 'Peak active power of current day', 'Active power', 'Reactive power', 'Power factor', 'Grid frequency',
    'Efficiency', 'Internal temperature', 'Insulation resistance', 'Device status', 'Fault code', 'Startup time', 'Shutdown time', 'Accumulated energy yield', 'Daily energy yield', '[Energy storage] Rated capacity', '[Energy storage] Remaining capacity"',
    '[Energy storage] Running status', '[Energy storage] Main Line voltage', '[Energy storage] Main Line current', '[Energy storage] Charge and discharge power', '[Energy storage] Accumulated charge capacity', '[Energy storage] Accumulated discharge capacity',
    '[Energy storage] Current-day charge capacity', '[Energy storage] Current-day discharge capacity'],
  VBPC244GM2SDataItems:['Operation status', 'Abnormality contents', 'Grid linkage status', 'Linkage input/output instant power', 'Linkage output accumulated power',
                      'Independent input/output instant power','Independent output accumulated power', 'Solar generation instant power', 'Solar generation accumulated power', 'Solar generation limit setting 2 (Power)', 
                      'Selling power limit setting (Power)', 'Output control judgement', 'Panel capacity'],
  ModelIILDataItems:["Voltage (Factor 0.1, unit V)","Current (Factor 0.01, unit A)","Power (Factor 0.1, unit W (signed))","Total energy (Factor 0.01, unit kWh)","Measure voltage direction (0: Forward 1: Backward)","Total energy (Total energy )","Import energy (Factor 0.01, unit kWh)","Export energy (Factor 0.01, unit kWh)","Import energy (Factor 0.001, unit kWh)","Export energy (Factor 0.001, unit kWh)","Current (Factor 0.01, unit A (signed))","Import power (Factor 0.1, unit W (signed))","Export power (Factor 0.1, unit W (signed))","Voltage high-byte (Factor 0.01, unit V)","Current (Factor 0.001, unit A (signed))","Power (Factor 0.001, unit W (signed))"],
  powerConditioner: {
    content: 'Contents',
    data: 'Reading Data',
    lastReportTime: 'Last Report Time',
    brand: 'Brand',
    mode: 'Model',
    node: 'Node',
    baudRate: 'Baud rate',
    command: 'item',
    responseCode: 'Response Code',
    selectBrand: 'Please select brand',
    selectModel: 'Please select model',
    selectNode: 'Please select node',
    selectCommand: 'Please select item',
    inputBaudRate: 'Please select baud rate',
    allCommand: 'All commands',
    onlyOneMeterSupport: 'Choose only one meter for setup',
    onlyPvMeterCanHandlePowerConditioner: 'Power conditioner operation only for PV meter',
  },
  ErrorMsg: {
    1008: 'Please wait for external device to response',
  },
  RsNetworkInstantValueCommandNames: ['Meter ID|0000|03', 'Meter Model|0003|03', 'QR code string|0006|08',
    '1st phase Voltage|000e|01', '1st phase Current|000f|01', '1st phase Frequency|0010|01', '1st phase Active Power|0011|01', '1st phase Reactive Power|0012|01',
    '2nd phase Voltage|0013|01', '2nd phase Current|0014|01', '2nd phase Frequency|0015|01', '2nd phase Active Power|0016|01', '2nd phase Reactive Power|0017|01',
    '3rd phase Voltage|0018|01', '3rd phase Current|0019|01', '3rd phase Frequency|001a|01', '3rd phase Active Power|001b|01', '3rd phase Reactive Power|001c|01',
    'Active Power|001d|01', 'Reactive Power|001f|01', 'Import Energy|0020|01', 'Export Energy|0021|01', 'Accumulate Pulse count|0022|01', 'Meter Status bit (0-9)|0023|01',
    'Route B Data Timetamp|0024|01', 'Route B Import Energy|0025|01', 'Route B Export Energy|0026|01', 'Route B 30m Data Timestamp|0027|01', 'Route B 30m Import Energy|0028|01', 'Route B 30m Export Energy|0029|01', 'Wi-SUN Status Timestamp|002a|01', 'Wi-Sun Status|002b|01',
    'Get all data|1111|44'],
  electricRecordDays: ["Today", "Yesterday", "2 Day before", "3 Day before", "4 Day before", "5 Day before", "6 Day before", "7 Day before", "8 Day before", "9 Day before",
    "10 Day before", "11 Day before", "12 Day before", "13 Day before", "14 Day before", "15 Day before", "16 Day before", "17 Day before", "18 Day before", "19 Day before",
    "20 Day before", "21 Day before", "22 Day before", "23 Day before", "24 Day before", "25 Day before", "26 Day before", "27 Day before", "28 Day before", "29 Day before",
    "30 Day before", "31 Day before", "32 Day before", "33 Day before", "34 Day before", "35 Day before", "36 Day before", "37 Day before", "38 Day before", "39 Day before",
    "40 Day before", "41 Day before", "42 Day before", "43 Day before", "44 Day before"],
  mqttType: {
    normal: "MQTT",
    tsl: "MQTT with TSL",
    aws: "AWS MQTT"
  }
};
